import { z } from "zod";
import { Chance } from "chance";

const chance = new Chance();

const getCustomValue = (schema: z.ZodType, key: string): string | null => {
	// if (schema.description === TemplateSchemaEnum.TemplateItem) {
	// 	if (key === "smsContent") {
	// 		return "Bonjour #(user.firstName) #(user.lastName), \n\nVous avez rendez-vous dans 2 heures chez votre audioprothésiste #(user.firstName). (Le #(schedule.date) à #(schedule.time).)";
	// 	}
	// 	if (key === "content") {
	// 		return "Voici un contenu de template de mail";
	// 	}

	// 	// Ajouter d'autres cas personnalisés ici selon vos besoins
	// 	// Exemple:
	// 	// if (schema.description === "MonAutreSchema" && key === "monAttribut") {
	// 	//     return "Valeur personnalisée";
	// 	// }

	// 	return null;
	// };
};

export const factoryFromSchema = <T extends z.ZodType>(
	schema: T,
	howMany = 1
): z.infer<T>[] => {
	const shape = schema instanceof z.ZodObject ? schema.shape : {};
	const keys = Object.keys(shape);

	return Array.from({ length: howMany }).map((_, index) => {
		const obj: Record<string, any> = {};

		keys.forEach((key) => {
			const field = shape[key];

			if (key === "@id") {
				obj[key] = "Entity/" + (index + 1);
			} else if (key === "@type") {
				obj[key] = schema.description;
			} else if (key === "id") {
				obj[key] = index + 1;
			} else if (field instanceof z.ZodString) {
				// Vérifier s'il y a une valeur personnalisée pour ce schéma et cet attribut
				const customValue = getCustomValue(schema, key);
				obj[key] = customValue != null ? customValue : chance.string();
			} else if (field instanceof z.ZodNumber) {
				obj[key] = chance.integer();
			} else if (field instanceof z.ZodBoolean) {
				obj[key] = chance.bool();
			} else if (field instanceof z.ZodEnum) {
				const { options } = field;
				obj[key] = chance.pickone(options);
			} else if (field instanceof z.ZodEnum) {
				const { enum: enumValues } = field;
				obj[key] = chance.pickone(Object.values(enumValues));
			} else if (field instanceof z.ZodDate) {
				const [year, month, day] = chance.date().toISOString().split("T")[0].split("-");
				obj[key] = `${day}/${month}/${year}`;
			} else {
				obj[key] = null;
			}
		});

		return obj as z.infer<T>;
	});
};

export const factoryFromSchemaSerialized = <T extends z.ZodType>(
	schema: T,
	howMany = 1
): Record<number, z.infer<T>> => {
	const items = factoryFromSchema(schema, howMany);
	return items.reduce((acc, item, index) => {
		const id = index + 1;
		return { ...acc, [id]: { ...item, id } };
	}, {} as Record<number, z.infer<T>>);
};

export const factoryFromSchemaSerializedWithEntitiesAndIds = <T extends z.ZodType>(
	schema: T,
	howMany = 1
): { entities: Record<number, z.infer<T>>; ids: number[] } => {
	const items = factoryFromSchema(schema, howMany);

	const serializedItems = items.reduce((acc, item, index) => {
		const id = index + 1;
		return { ...acc, [id]: { ...item, id } };
	}, {} as Record<number, z.infer<T>>);

	return {
		entities: serializedItems,
		ids: Object.keys(serializedItems).map(Number)
	};
};
